module.exports = __webpack_public_path__ + "img/overheads-representation.013994cc.svg";